import Vue from 'vue';
import VueMq from 'vue-mq';
// import VueObserveVisibility from 'vue-observe-visibility';
import { LMap, LTileLayer, LMarker, LTooltip, LIcon, LControlZoom, LControlAttribution, LPopup } from 'vue2-leaflet';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import LMarkerCluster from 'vue2-leaflet-markercluster';
import LProtobuf from 'vue2-leaflet-vectorgrid';
import App from './App.vue';
import VueLazyload from 'vue-lazyload';

Vue.config.productionTip = false;

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-icon', LIcon);
Vue.component('l-marker-cluster', LMarkerCluster);
Vue.component('l-tooltip', LTooltip);
Vue.component('l-popup', LPopup);
Vue.component('l-control-zoom', LControlZoom);
Vue.component('l-control-attribution', LControlAttribution);
Vue.component('l-protobuf', LProtobuf);

// Vue.use(VueObserveVisibility);

Vue.use(VueMq, {
    breakpoints: {
        'mobile': 450,
        'tablet': 950,
        'laptop': 1250,
        'desktop': Infinity,
    }
});

Vue.use(VueLazyload, {
    preLoad: 2
});

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
    iconRetinaUrl: require('../src/assets/images/icons/pin-icon-2x.png'),
    iconUrl: require('../src/assets/images/icons/pin-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

new Vue({
    render: h => h(App),
}).$mount('#app');